import ACTION_TYPE from 'components/../redux/actions/actionTypes';

const initialState = {
    loading: false,
    data: [],
    total: 0,
    searchParams: {
        id: 0,
        page: 0,
        page_size: 25,
        keyword: '',
        group_name: '',
        category_name: ''
    },
    error: null,
    success: false
};

const deviceReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPE.SEARCH_DEVICES_REQ:
            return {
                ...state,
                loading: true
            };
        case ACTION_TYPE.SEARCH_DEVICES:
            const { data, category_name, group_name, page, page_size, total } = action.data;
            return {
                data,
                total,
                searchParams: { ...state.searchParams, category_name, group_name, page, page_size },
                loading: false,
                error: null,
                success: true
            };
        case ACTION_TYPE.SEARCH_DEVICES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.data,
                success: false
            };
        case ACTION_TYPE.SEARCH_PARAM_UPDATE:
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    ...action.data
                }
            };
        case ACTION_TYPE.AUTH_LOGOUT:
            return initialState;
        default:
            return state;
    }
};

export default deviceReducer;
